// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0d419005","455":"64c34417","977":"218cd6ef"}[chunkId] + ".chunk.js";
};